import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
// components
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store';
// loader
import Loader from './assets/images/file_uploader.gif';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <React.Suspense fallback={() => <Loader />}>
          <Route path='/' component={App} />
        </React.Suspense>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
  document.body.classList.add('body')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
